import { serviceBackgroundChecks } from "./serviceBackgroundChecks";
import {
  IBackgroundCheckSettingsCreateRequest,
  IBackgroundCheckSettingsResponse
} from "@wingspanhq/background-checks/dist/lib/interfaces";

export type IUpdateBackgroundCheckUpdateRequest = {
  instructions: string;
};

export const updateBackgroundChecksSettings = async (
  requirementSettingsId: string,
  request: IUpdateBackgroundCheckUpdateRequest
): Promise<IBackgroundCheckSettingsResponse> => {
  const { data } = await serviceBackgroundChecks.patch(
    `/settings/${requirementSettingsId}`,
    request
  );
  return data;
};
